import { render, staticRenderFns } from "./Banner001MasAnadido.vue?vue&type=template&id=2d155f3f"
import script from "./Banner001MasAnadido.vue?vue&type=script&lang=js"
export * from "./Banner001MasAnadido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports